import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Footer from '../components/footer';
import Header from '../components/header';

import '../../sass/style.scss';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet>
      <title>Steuerberater ETL Filter, Raitz & Kollegen</title>
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "legalName": "ETL Filter, Raitz und Kollegen GmbH",
            "description": "Steuerberatungsgesellschaft",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "DE",
              "addressRegion": "Hessen",
              "addressLocality": "Langen",
              "postalCode": "63225",
              "streetAddress": "Elisabeth-Selbert-Allee 9"
            },
            "url": "https://www.frk-steuerberater.de/",
            "email": "kanzlei@frk-steuerberater.de",
            "telephone": "06103 / 90 12 0"
          }
        `}
      </script>
    </Helmet>
    <Header />
    {children()}
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js